import React from 'react'

const Send = ({ ...props }) => (
  <div {...props}>
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2071 0.79292C18.475 1.06075 18.5685 1.45692 18.4487 1.81625L12.9487 18.3163C12.8289 18.6758 12.516 18.9367 12.1408 18.9901C11.7656 19.0434 11.3924 18.8801 11.1771 18.5682L8.6771 14.9471C8.36332 14.4926 8.47739 13.8698 8.93188 13.556C9.38637 13.2422 10.0092 13.3563 10.323 13.8108L11.6848 15.7834L15.9189 3.08117L3.1508 7.33719L7.24571 10.3401L9.09528 8.49056C9.03342 8.29778 9.00003 8.09226 9.00003 7.87893C9.00003 6.77436 9.89546 5.87893 11 5.87893C12.1046 5.87893 13 6.77436 13 7.87893C13 8.9835 12.1046 9.87893 11 9.87893C10.8558 9.87893 10.7152 9.86367 10.5796 9.83467L8.06431 12.35C8.05649 12.358 8.04856 12.366 8.04052 12.3737L8.0068 12.4075L8.00542 12.4061C7.6606 12.7089 7.14017 12.7429 6.75482 12.4603L0.408662 7.80643C0.107165 7.58534 -0.0458122 7.21452 0.0120906 6.84515C0.0699948 6.47579 0.329107 6.16957 0.683797 6.05134L17.1838 0.551344C17.5431 0.431566 17.9393 0.525088 18.2071 0.79292Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="18.5001"
          y1="19.0001"
          x2="-0.00707638"
          y2="2.61027"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2BFFFF" />
          <stop offset="0.592551" stopColor="#28B8E3" />
          <stop offset="1" stopColor="#114057" />
        </linearGradient>
      </defs>
    </svg>
  </div>
)

export default Send
